export default __webpack_public_path__ + "static/media/wireframes_tutorial_3.af3aff29.png";